var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var appEnvMap = {
    live: {
        serverUrl: 'https://api.crosstheages.com/api',
        serverSsoUrl: "https://sso.crosstheages.com/api",
        serverAuthUrl: "https://auth.crosstheages.com/api",
        serverAccountUrl: "https://account.crosstheages.com/api",
        websiteUrl: "https://www.crosstheages.com",
        loginClientUrl: "https://login.crosstheages.com",
        portalUrl: "https://portal.crosstheages.com",
        blockchain: {
            magicLinkApiKey: 'pk_live_DC29A65A3D8E3BCC',
        },
    },
    testing: {
        serverUrl: 'https://globalhttp.cta-tcg-testing.com/api',
        serverSsoUrl: "https://sso.testing.crosstheages.com/api",
        serverAuthUrl: "https://auth.testing.crosstheages.com/api",
        serverAccountUrl: "https://account.testing.crosstheages.com/api",
        websiteUrl: "https://testing.crosstheages.com",
        loginClientUrl: "https://login.testing.crosstheages.com",
        portalUrl: "https://portal.testing.crosstheages.com",
        blockchain: {
            magicLinkApiKey: 'pk_live_83936566D9123D25',
        },
    },
    dev: {
        serverUrl: 'https://globalhttp.cta-tcg-dev2.com/api',
        serverSsoUrl: "https://sso.dev.crosstheages.com/api",
        serverAuthUrl: "https://auth.dev.crosstheages.com/api",
        serverAccountUrl: "https://account.dev.crosstheages.com/api",
        websiteUrl: "https://dev.crosstheages.com",
        loginClientUrl: "https://login.dev.crosstheages.com",
        portalUrl: "https://portal.dev.crosstheages.com",
        blockchain: {
            magicLinkApiKey: 'pk_live_83936566D9123D25',
        },
    },
    dev1: {
        serverUrl: 'https://globalhttp.cta-tcg-dev1.com/api',
        serverSsoUrl: "https://sso.dev1.crosstheages.com/api",
        serverAuthUrl: "https://auth.dev1.crosstheages.com/api",
        serverAccountUrl: "https://account.dev1.crosstheages.com/api",
        websiteUrl: "https://dev1.crosstheages.com",
        loginClientUrl: "https://login.dev1.crosstheages.com",
        portalUrl: "https://portal.dev1.crosstheages.com",
        blockchain: {
            magicLinkApiKey: 'pk_live_83936566D9123D25',
        },
    },
    dev2: {
        serverUrl: 'https://globalhttp.cta-tcg-dev2.com/api',
        serverSsoUrl: "https://sso.dev2.crosstheages.com/api",
        serverAuthUrl: "https://auth.dev2.crosstheages.com/api",
        serverAccountUrl: "https://account.dev2.crosstheages.com/api",
        websiteUrl: "https://dev2.crosstheages.com",
        loginClientUrl: "https://login.dev2.crosstheages.com",
        portalUrl: "https://portal.dev2.crosstheages.com",
        blockchain: {
            magicLinkApiKey: 'pk_live_83936566D9123D25',
        },
    },
    local: {
        // serverUrl: 'http://localhost:3000/local/api',
        serverUrl: 'https://globalhttp.cta-tcg-dev2.com/api',
        serverSsoUrl: 'http://localhost:4005/api',
        serverAuthUrl: 'http://localhost:4002/api',
        serverAccountUrl: 'http://localhost:4001/api',
        websiteUrl: 'http://localhost:4021',
        loginClientUrl: "http://localhost:4020",
        portalUrl: "http://localhost:4021",
        blockchain: {
            magicLinkApiKey: 'pk_live_83936566D9123D25',
        },
    },
};
var common = {
    isLocal: process.env.REACT_APP_ENV === 'local',
    isLive: process.env.REACT_APP_ENV === 'live',
    isTesting: process.env.REACT_APP_ENV === 'testing',
    isDev: process.env.REACT_APP_ENV === 'dev',
    isDev1: process.env.REACT_APP_ENV === 'dev1',
    isDev2: process.env.REACT_APP_ENV === 'dev2',
    server: {
        url: appEnvMap[process.env.REACT_APP_ENV || ''].serverUrl,
        ssoUrl: appEnvMap[process.env.REACT_APP_ENV || ''].serverSsoUrl,
        authUrl: appEnvMap[process.env.REACT_APP_ENV || ''].serverAuthUrl,
        accountUrl: appEnvMap[process.env.REACT_APP_ENV || ''].serverAccountUrl,
    },
    client: {
        websiteUrl: appEnvMap[process.env.REACT_APP_ENV || ''].websiteUrl,
        loginClientUrl: appEnvMap[process.env.REACT_APP_ENV || ''].loginClientUrl,
        portalUrl: appEnvMap[process.env.REACT_APP_ENV || ''].portalUrl,
    },
    blockchain: appEnvMap[process.env.REACT_APP_ENV || ''].blockchain,
};
export var appEnv = __assign({}, common);
